import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function ThankYouPage() {
  return <div className="w-full min-h-screen bg-lightGray flex flex-col" data-id="element-212">
      <Navbar data-id="element-213" />

      <div className="flex-grow flex items-center justify-center px-4 py-16" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="max-w-2xl w-full bg-white rounded-lg shadow-2xl p-8 md:p-12 text-center" data-id="element-215">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} data-id="element-216">
            <CheckCircle className="mx-auto text-green-500 mb-6" size={80} data-id="element-217" />
          </motion.div>

          <h1 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-218">
            ¡Gracias por tu solicitud!
          </h1>

          <div className="w-16 h-1 bg-gold mx-auto mb-6" data-id="element-219"></div>

          <p className="text-lg text-gray-700 mb-6" data-id="element-220">
            Hemos recibido tu información. Un especialista la revisará en las
            próximas 24-48 horas.
          </p>

          <div className="bg-lightGray p-6 rounded-lg mb-8" data-id="element-221">
            <p className="text-gray-700" data-id="element-222">
              <strong className="text-navy" data-id="element-223">Nuestro compromiso:</strong> Si
              vemos una oportunidad real para mejorar fees, servicio o POS, nos
              pondremos en contacto contigo. Si no podemos mejorar tu situación
              actual, te lo diremos honestamente.
            </p>
          </div>

          <div className="space-y-4" data-id="element-224">
            <Link to="/" className="inline-block bg-gold text-navy px-8 py-3 rounded-md font-semibold hover:bg-opacity-90 transition-all shadow-lg" data-id="element-225">
              Volver al inicio
            </Link>

            <p className="text-sm text-gray-500" data-id="element-226">
              ¿Tienes preguntas? Contáctanos al (954) 931-4833
            </p>
          </div>
        </motion.div>
      </div>

      <Footer data-id="element-227" />
    </div>;
}